import { Component } from '@angular/core';

@Component({
  selector: 'pt-production-order-list',
  templateUrl: './production-order-list.component.html',
  styleUrls: ['./production-order-list.component.scss']
})
export class ProductionOrderListComponent {}
